(ns iris.fingerprint 
  (:require
   [re-frame.core :as re-frame] 
   ["@fingerprintjs/fingerprintjs" :as Fingerprint2]
   [iris.events :as events]))


 
;; NOTE: interop with js, converting components data to cljs will not give accurate fp

 (def device-keys #js ["availableScreenResolution"
                       "colorDepth"
                       "hardwareConcurrency"
                       "platform"
                       "screenResolution"
                       "timezone"
                       "timezoneOffset"
                       "touchSupport"])
 

(defn set-fp [hash]
  (re-frame/dispatch [::events/set-fp hash]))
 

(defn set-dfp [hash]
  (re-frame/dispatch [::events/set-dfp hash]))
 

(defn get-hash [s]
  (.x64hash128 Fingerprint2 s 31))
 
 
 (defn dfp [pair]
   (cond (= (.-key pair) "platform")
         (subs (.-value pair) 0 3)
         (= (.-key pair) "screenResolution")
         (let [res (* (aget (.-value pair) 0) (aget (.-value pair) 1))
               s (* (* 375 667) 0.05)
               m (* (* 768 1024) 0.05)
               l (* (* 1920 1080) 0.05)]
           (cond (< res s) "xs"
                 (and (>= res s) (< res m)) "s"
                 (and (>= res m) (< res l)) "m"
                 (>= res l) "l"))
         :else
         (.-value pair)))


(defn fp-components-handler [components]
;; fp    
  (-> components
      (.map #(.-value %))
      (.join)
      (get-hash)
      (set-fp))
;; dfp
  (-> components
      (.filter #(> (.indexOf device-keys (.-key %)) -1))
      (.map #(dfp %))
      (.join)
      (get-hash)
      (set-dfp)))


(defn idle-callback-handler []
  (.get Fingerprint2 fp-components-handler))

(if (exists? (.-requestIdleCallback js/window))
  (js/requestIdleCallback idle-callback-handler)
  (js/setTimeout idle-callback-handler 500))









;; {"t":"d","d":{"r":5,"a":"p","b":{"p":"/sessions/C7kNdxPnFOh8rM6uPjQKRxrZyOJ2/share-log/-NIbtJqqJ46YlXDCddL-","d":{"action":"tw","datetime":{".sv":"timestamp"},"fp":"519249c6cba666246634f723fe89f419","fpdevice":"3a21cf7b49f2717a17f98db034720ce7","kind":"node","ruid":"/_homepage.TLO","sid":"d7bebf33-c6eb-4fd1-9ae2-1374cb9f57dd","ws":"TLO"}}}}


;; #js [#js {:key colorDepth, :value 24} #js {:key hardwareConcurrency, :value 8} #js {:key screenResolution, :value #js [1920 1080]} #js {:key availableScreenResolution, :value #js [1920 1048]} #js {:key timezoneOffset, :value -60} #js {:key timezone, :value Europe/Sarajevo} #js {:key platform, :value Linux x86_64} #js {:key touchSupport, :value #js [0 false false]}]